import {
    Avatar,
    Card,
    CardHeader,
    CardContent,
    Collapse,
    IconButton,
} from '@material-ui/core'
import React, { useState } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleUp } from '@fortawesome/pro-solid-svg-icons';

/**
 * 
 * @param {{
 *  stepNumber: number,
 *  classes: *,
 *  title: string,
 *  isCollapsable: boolean,
 *  expanded?: boolean,
 *  children: *,
 * }} param0 
 */
const NumberedStepContainer = ({ stepNumber, classes, title, isCollapsable = false, expanded = false, children }) => {
    const [internalExpanded, setInternalExpanded] = useState(expanded);
    return (
        <Card className={classes.cards}>
            <CardHeader
                className={classes.numberedStepContainerCardHeader}
                classes={{ action: classes.numberedStepContainerCardAction }}
                style={{ title: classes.sidePanelStepHeader }}
                color="textSecondary"
                gutterBottom
                avatar={<Avatar className={classes.avatar}>{stepNumber}</Avatar>}
                title={title}
                action={isCollapsable && (
                    <IconButton onClick={() => setInternalExpanded(x => !x)}>
                        <FontAwesomeIcon icon={internalExpanded ? faAngleUp : faAngleDown} />
                    </IconButton>
                )}
            />
            {isCollapsable ? (
                <Collapse in={internalExpanded} timeout="auto" unmountOnExit>
                    <CardContent className={classes.numberedStepContainerCardContent}>
                        {children}
                    </CardContent>
                </Collapse>) : (
                <CardContent className={classes.numberedStepContainerCardContent}>
                    {children}
                </CardContent>)
                }
        </Card>
    );
}

export default NumberedStepContainer;
